import { MaterialUnitType, mapMaterialUnitType } from "./MaterialUnitType";

export interface MaterialEstimationType {
    id: number;
    material_data_id: number | null;
    item_name: string | null;
    unit_id: number | null;
    quantity: number | null;
    unit_price: number | null;
    sub_total: number | null;
    percentage: number | null;
    note: string | null;
    include_tax: 1 | 0;
    unit: MaterialUnitType | null;
}

// to single object maping
export const mapMaterialEstimationType = (data: any): MaterialEstimationType => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const materialEstimationType: MaterialEstimationType = {
        id: data.id,
        material_data_id: data.material_data_id || null,
        item_name: data.item_name || null,
        unit_id: data.unit_id || null,
        quantity: data.quantity || null,
        unit_price: data.unit_price || null,
        sub_total: data.sub_total || null,
        percentage: data.percentage || null,
        note: data.note || null,
        include_tax: data.include_tax,
        unit: data.unit !== null ? mapMaterialUnitType(data.unit) : null,
    }

    return materialEstimationType;
}

// maping list objects
export const mapMaterialEstimationTypes = (data: any[]): MaterialEstimationType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapMaterialEstimationType);
}